import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentCalled from './ContentCalled';

const Called = () => {
  return (
    <>
      <Header />
      <ContentCalled />
      <Bottom />
    </>
  );
};

export default Called;
